import request from '@/utils/request'
// import serviceConfig from '@/api/serviceConfig'

// 华夏
const servinceBase='https://test.saas.api.yidianlife.cn/saas-custom-api'
export function getAuthorize(url='https://test.yidianlife.com/yxl1/#/hxlogin') {
  return request({
    url: `${servinceBase}/huaxia/oauthOauth?redirectUri=${encodeURIComponent(url)}`,
    method: 'get'
  })
}
export function getAccessToken(data) {
  return request({
    url: `${servinceBase}/huaxia/accessToken?code=${data}`,
    method: 'get',
    data
  })
}
export function getJsSdk(url) {
  return request({
    url: `${servinceBase}/huaxia/initJsSdk?url=${encodeURIComponent(url)}`,
    method: 'get'
  })
}
export function getPay(data) {
  return request({
    url: `${servinceBase}/huaxia/pay/order`,
    method: 'post',
    data
  })
}
export function getOrder(data) {
  return request({
    url: `${servinceBase}/huaxia/pay/getPage`,
    method: 'post',
    data
  })
}
export function refundOrder(data) {
  return request({
    url: `${servinceBase}/huaxia/pay/refund`,
    method: 'post',
    data
  })
}
// 美团M站
export function getmtPay(data) {
  return request({
    url: `${servinceBase}/meituan/ydPay`,
    method: 'post',
    data
  })
}